// src/redux/actions/authActions.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const login = (email, password) => async (dispatch) => {
  try {
    // Dispatch loading state
    dispatch({ type: "LOGIN_REQUEST" });

    const res = await axios.post(
      `${BASE_URL}/v1/api/login-admin`,
      { email, password },
      { headers: { "Content-Type": "application/json" } }
    );

    if (res.data?.meta?.status) {
      // Store in localStorage
      localStorage.setItem("token", res.data.data.token);
      localStorage.setItem("userData", JSON.stringify(res.data.data));
      
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data.data,
      });

      return res.data;
    } else {
      dispatch({ 
        type: "LOGIN_FAIL", 
        payload: res.data?.meta?.message || "Login failed" 
      });
      return res.data;
    }
  } catch (error) {
    const errorMessage = error.response?.data?.meta?.message || 
                        error.message || 
                        "Login failed";
    
    dispatch({ 
      type: "LOGIN_FAIL", 
      payload: errorMessage 
    });
    
    console.error("Login API Error:", error.response || error);
    throw error;
  }
};

export const logout = () => (dispatch) => {
  localStorage.clear();
  dispatch({ type: "LOGOUT" });
};